<!--
 Created by Volodymyr Mak. on 7/5/2020.
 Copyright © 2020 Curriculum Ltd. All rights reserved.
-->

<div class="curr-profile">
  <div class="page-title">
    {{ 'student.profile.title' | translate }}
  </div>

  <div class="student-profile">
    <div class="profile-left-panel">
      <curr-profile-card (updateUserCard)="updateUserProfile($event)" [profileData]="profileData"></curr-profile-card>

      <ng-container *currHasRoles="[userRole.SchoolAdmin, userRole.Teacher]">
        <curr-notes-about-student
          *ngIf="userProfile && studId"
          [currUser]="userProfile"
          [studId]="studId">
        </curr-notes-about-student>
      </ng-container>
      <curr-student-bio-card></curr-student-bio-card>
    </div>

    <div class="profile-right-panel">
      <ng-container *currHasRoles="[userRole.SchoolAdmin, userRole.Teacher, userRole.Student]">
        <curr-student-performance-chart [studentId]="studId"></curr-student-performance-chart>
        <!-- <curr-dashboard-chart *currHasRoles="[userRole.Teacher, userRole.Student]" noDataImage="assets/images/no-graph-data.png"></curr-dashboard-chart>
        <curr-school-admin-chart *currHasRoles="[userRole.SchoolAdmin]"></curr-school-admin-chart> -->
        <!-- <curr-student-profile-test-archive [testArchive]="testArchive" *ngIf="testArchive.length"></curr-student-profile-test-archive> -->
        <curr-student-profile-subject-table
          [userRole]="currUser.role"
          [tableData]="tableData"
          [currentProfileData]="currentProfileData"
          (onSetPredictedGrade)="savePredictedGrade($event)"></curr-student-profile-subject-table>
      </ng-container>
    </div>
  </div>
</div>
